import Api from "./Api";

export default class VehicleTagApi extends Api {
  constructor() {
    super(process.env.REACT_APP_HOTLIST_SPOTLIGHT_ENDPOINT);
  }
}
